import { Line } from 'vue-chartjs'
import * as d3 from "d3";
export default {
  extends: Line,
  data: () => ({
    labels: [],
    data: [],
    p1: [],
    p2: [],
    p3: [],
    p4gbg: [],
    p4sthm: [],
    p4mlm: [],
    p4jkp: [],
    p4gtl: [],
    spotifyse: [],
    // full (unfiltered) copies
    fullLabels: [],
    fullP1: [],
    fullP2: [],
    fullP3: [],
    fullP4gbg: [],
    fullP4sthm: [],
    fullP4mlm: [],
    fullP4jkp: [],
    fullP4gtl: [],
    fullSpotifyse: []
  }),
  mounted () {
    this.logTest()
    this.loadData()
    // react to date range changes
    if (this.$store && this.$store.watch) {
      this.$store.watch(
        state => state.dateRange,
        () => {
          this.filterAndRender()
        }
      )
    }
  },
  methods: {
      loadData: function() {
        d3.csv('https://radio-kollen-public.s3-eu-west-1.amazonaws.com/percentage-collection.csv', (data) => {
            this.fullP1.push(parseInt(data['p1']));
            this.fullP2.push(parseInt(data['p2']));
            this.fullP3.push(parseInt(data['p3']));
            this.fullP4gbg.push(parseInt(data['p4gbg']));
            this.fullP4sthm.push(parseInt(data['p4sthm']));
            this.fullP4mlm.push(parseInt(data['p4mlm']));
            this.fullP4jkp.push(parseInt(data['p4jkp']));
            this.fullP4gtl.push(parseInt(data['p4gtl']));
            this.fullSpotifyse.push(parseInt(data['spotifyse']));
            this.fullLabels.push(data['date']);
        }).then( () => {
            this.filterAndRender()
        }
        );
      },
      filterAndRender: function() {
        // derive filtered arrays
        const start = this.$store && this.$store.state.dateRange.start ? this.$store.state.dateRange.start : null
        const end = this.$store && this.$store.state.dateRange.end ? this.$store.state.dateRange.end : null
        const labels = []
        const p1 = []
        const p2 = []
        const p3 = []
        const p4gbg = []
        const p4sthm = []
        const p4mlm = []
        const p4jkp = []
        const p4gtl = []
        const spotifyse = []
        for (let i = 0; i < this.fullLabels.length; i++) {
          const date = this.fullLabels[i]
          if ((start === null || date >= start) && (end === null || date <= end)) {
            labels.push(date)
            p1.push(this.fullP1[i])
            p2.push(this.fullP2[i])
            p3.push(this.fullP3[i])
            p4gbg.push(this.fullP4gbg[i])
            p4sthm.push(this.fullP4sthm[i])
            p4mlm.push(this.fullP4mlm[i])
            p4jkp.push(this.fullP4jkp[i])
            p4gtl.push(this.fullP4gtl[i])
            spotifyse.push(this.fullSpotifyse[i])
          }
        }
        this.labels = labels
        this.p1 = p1
        this.p2 = p2
        this.p3 = p3
        this.p4gbg = p4gbg
        this.p4sthm = p4sthm
        this.p4mlm = p4mlm
        this.p4jkp = p4jkp
        this.p4gtl = p4gtl
        this.spotifyse = spotifyse
        this.renderChart({
                  labels: this.labels,
                  datasets: [
                    {
                      type: 'line',
                      label: 'SR P1',
                      borderColor: 'rgb(93, 189, 204)',
                      data: this.p1,
                      fill: false
                    },
                    {
                      type: 'line',
                      label: 'SR P2',
                      borderColor: 'rgb(229, 127, 58)',
                      data: this.p2,
                      fill: false

                    },
                    {
                      type: 'line',
                      label: 'SR P3',
                      borderColor: 'rgb(78, 173, 143)',
                      data: this.p3,
                      fill: false
                    },
                    {
                      type: 'line',
                      label: 'SR P4 (Gotland)',
                      borderColor: 'rgb(195, 30, 170)',
                      data: this.p4gtl,
                      fill: false
                    },
                    {
                      type: 'line',
                      label: 'SR P4 (Göteborg)',
                      borderColor: 'rgb(166, 61, 142)',
                      data: this.p4gbg,
                      fill: false
                    },
                    {
                      type: 'line',
                      label: 'SR P4 (Jönköping)',
                      borderColor: 'rgb(197, 215, 237)',
                      data: this.p4jkp,
                      fill: false
                    },
                    {
                      type: 'line',
                      label: 'SR P4 (Malmöhus)',
                      borderColor: 'rgb(30, 21, 93)',
                      data: this.p4mlm,
                      fill: false
                    },
                    {
                      type: 'line',
                      label: 'SR P4 (Stockholm)',
                      borderColor: 'rgb(194, 175, 230)',
                      data: this.p4sthm,
                      fill: false
                    },
                    {
                      type: 'line',
                      label: 'Spotify Sverige (Top 50)',
                      borderColor: 'rgb(30, 215, 96)',
                      data: this.spotifyse,
                      fill: false
                    }
                    /** 
                     * Mer P4:
                     * 28/41/167
                     * https://sverigesradio.se/diverse/appdata/isidor/files/3113/9463.pdf
                     * 
                    */
                  ]}, {
                    title: {
                      display: false,
                      text: ''
                    },
                    scales: {
                      yAxes: [{
                        stacked: false,
                        scaleLabel: {
                          display: true,
                          labelString: 'Andel musiker som är kvinnliga (%)'
                        },
                        ticks: {
                          beginAtZero: true,
                          suggestedMax: 50,
                        },
                      }],
                      xAxes: [ {
                        stacked: false,
                        categoryPercentage: 0.5,
                        barPercentage: 1
                      }]
                    },
                    legend: {
                      display: true
                    },
                    responsive: true,
                    maintainAspectRatio: false
                  }
                )
      },
      logTest: function() {
          //console.log("Hello!")
      }
  }
}